import { atom } from 'jotai';

import { deviceNameSelector } from 'store/my-robot/myRobot.selectors';

import { manipulatorStateAtom } from './atoms';

export const manipulatorStateStowedSelector = atom((get) => {
  const deviceName = get(deviceNameSelector);
  const { stowState } = get(manipulatorStateAtom(deviceName));
  return { stowState };
});
manipulatorStateStowedSelector.debugLabel = 'Relay Topics/Manipulator State Stowed Selector';

export const gripperOpeningPercentageSelector = atom((get) => {
  const deviceName = get(deviceNameSelector);
  const { gripperOpenPercentage } = get(manipulatorStateAtom(deviceName));
  return gripperOpenPercentage;
});
gripperOpeningPercentageSelector.debugLabel = 'Relay Topics/Gripper Opening Percentage Selector';

export const gripperHoldingItemSelector = atom((get) => {
  const deviceName = get(deviceNameSelector);
  const { isGripperHoldingItem } = get(manipulatorStateAtom(deviceName));
  return isGripperHoldingItem;
});
gripperHoldingItemSelector.debugLabel = 'Relay Topics/Gripper Holding Item Selector';

export const carryStateSelector = atom((get) => {
  const deviceName = get(deviceNameSelector);
  const { carryState } = get(manipulatorStateAtom(deviceName));
  return carryState;
});
carryStateSelector.debugLabel = 'Relay Topics/Carry State Selector';
